// @ts-nocheck
import _ from 'lodash';
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { makeStyles, Box, Button, Typography, Icon } from '@material-ui/core';
import { GridOverlay, GridToolbarContainer } from '@material-ui/data-grid';
import { useDialog, useIfMounted } from '../../../../common/hooks';
import { DataTable, EmptyState } from '../../../../common/components';
import { DateUtils } from '../../../../common/utils';

const useStyles = makeStyles(() => ({
  container: {
    height: '100%',
    '& .MuiDataGrid-root': {
      border: '0',
    },
  },
}));

function TapsList(props) {
  const [selectedTaps, setSelectedTaps] = useState([]);
  const [t] = useTranslation();
  const { showDialog } = useDialog();
  const classes = useStyles();
  const ifMounted = useIfMounted();

  const { data, removed, onClearTaps, actionsDisabled } = props;

  const getColumnDefs = () => [
    {
      field: 'consentType',
      headerName: t('taps.tapsKey'),
      width: 200,
    },
    {
      field: 'name',
      headerName: t('taps.tapsName'),
      width: 300,
      flex: 1,
    },
    {
      field: 'acceptedDate',
      headerName: t('taps.tapsAcceptedDate'),
      width: 200,
      type: 'dateTime',
      valueFormatter: params => DateUtils.getDateTime(params.value),
    },
    {
      field: 'discardedDate',
      headerName: t('taps.tapsDiscardedDate'),
      width: 200,
      type: 'dateTime',
      valueFormatter: params => DateUtils.getDateTime(params.value),
    },
    {
      field: 'contextPlatform',
      headerName: t('taps.tapsContextPlatform'),
      width: 250,
    },
    {
      field: 'contextApplication',
      headerName: t('taps.tapsContextApplication'),
      width: 250,
    },
  ];

  const getRowData = () =>
    [...data?.terms.map(taps => ({
      ...taps,
      id: taps.consentType,
    })),
    ...data?.permissions.map(taps => ({
      ...taps,
      id: taps.consentType,
    }))];

  const handleShowClearTapsDialog = () => {
    showDialog({
      title: t('common.important'),
      content: <Typography>{t('taps.tapsClearConfirm')}</Typography>,
      onConfirm: async () => {
        await onClearTaps(selectedTaps);
        ifMounted(() => setSelectedTaps([]));
      },
    });
  };

  const handleSelectTaps = params => {
    const { selectionModel } = params;
    setSelectedTaps(selectionModel);
  };

  const isRowSelectable = params => {
    return params.row.canBeDiscarded && params.row.accepted && removed.indexOf(params.row.consentType) === -1;
  }

  const renderToolbar = () => (
    <GridToolbarContainer>
      <Button
        id="TapsList-clearTaps"
        variant="outlined"
        color="primary"
        startIcon={<Icon>cancel_presentation</Icon>}
        onClick={handleShowClearTapsDialog}
        disabled={actionsDisabled || _.isEmpty(selectedTaps)}
      >
        {t('taps.tapsClear')}
      </Button>
    </GridToolbarContainer>
  );

  const renderNoRowsOverlay = () => (
    <GridOverlay>
      <EmptyState variant="empty" message={t('taps.tapsEmpty')} />
    </GridOverlay>
  );

  return (
    <Box id="TapsList-container" className={classes.container}>
      <DataTable
        id="TapsList-table"
        components={{
          Toolbar: renderToolbar,
          NoRowsOverlay: renderNoRowsOverlay,
        }}
        columns={getColumnDefs()}
        rows={getRowData()}
        selectionModel={selectedTaps}
        onSelectionModelChange={handleSelectTaps}
        pageSize={20}
        paginationMode="client"
        pagination
        checkboxSelection
        isRowSelectable={isRowSelectable}
      />
    </Box>
  );
}

TapsList.propTypes = {
  data: PropTypes.object.isRequired,
  removed: PropTypes.arrayOf(PropTypes.string).isRequired,
  onClearTaps: PropTypes.func.isRequired,
  actionsDisabled: PropTypes.bool.isRequired,
};

export default TapsList;
